import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import {useEffect, useState} from "react";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import React from "react";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import RaikoDateInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoDateInputOutlined";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";
import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import {MultiMediaService} from "../../pages/multiMediaList/MultiMediaService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useParams} from "react-router-dom";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoCustomAparatInput from "../../raikoComponents/raikoCustomAparatInput/RaikoCustomAparatInput";
import {css} from "@emotion/css";
import DatePicker, {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const VideoDetailBasicInformation = () => {


    const service = new MultiMediaService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const {id} = useParams()

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            getDataFromServer()
        }
    }, [id])

    function getDataFromServer() {
        loading.show()
        service.getVideoDetailFromServer(id)
            .then(({globalInfo, published: publishedState}) => {

                setPublished(publishedState.published)

                setTitle(globalInfo.title)
                setVideoLink(globalInfo.videoLink)
                setShortDescription(globalInfo.shortDescription)
                setCreatedAt(convertUniversalDateToPersianDate(globalInfo.createdAt))
                setCreatedBy(globalInfo.createdBy)

                if (publishedState.publishDate && publishedState.publishDate.length > 0)
                    setPublishedDate(new Date(publishedState.publishDate))

                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات ویدیو"))
            loading.hide()
        })
    }

    const [title, setTitle] = useState("")
    const [videoLink, setVideoLink] = useState("")
    const [shortDescription, setShortDescription] = useState("")
    const [createdBy, setCreatedBy] = useState("")
    const [createdAt, setCreatedAt] = useState("")
    const [published, setPublished] = useState(true)
    const [publishedDate, setPublishedDate] = useState("");

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false)

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function doUpdatePublishedState(_published, _newPublishDate) {

        loading.show()


        service.updateMultiMediaPublished(id, _published, _newPublishDate)
            .then(response => {
                handleCloseConfirmDialog()
                setPublished(response.published)
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی وضعیت انتشار"))
            loading.hide()
        })
    }

    function handleChangeEnableSetting() {
        if (publishedDate) {

            const _newPublishDate = new DateObject(publishedDate).format("YYYY-MM-DD")

            doUpdatePublishedState(!published, _newPublishDate);
        } else {
            snackbar.showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }
    }

    function handleUpdatePublishedDate() {
        if (publishedDate) {
            const _newPublishDate = new DateObject(publishedDate).format("YYYY-MM-DD")

            doUpdatePublishedState(published, _newPublishDate);
        } else {
            snackbar.showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }
    }

    function checkFields() {
        let message = ""
        let state = false

        if (title.length === 0) {
            message = "لطفا عنوان ویدیو را به درستی وارد نمایید."
        } else if (videoLink.length === 0) {
            message = "لطفا لینک آپارات ویدیو را به درستی وارد نمایید."
        } else if (!shortDescription || shortDescription.length === 0) {
            message = "لطفا توضیحات کوتاه ویدیو را به درستی وارد نمایید."
        } else
            state = true


        snackbar.showWarningMessage(message)
        return state
    }

    function handleUpdateGlobalInfo() {
        if (checkFields()) {
            loading.show()
            service.updateMultiMediaGlobalInfo(
                id,
                title,
                videoLink,
                shortDescription
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی جزئیات ویدیو."))
                loading.hide()
            })
        }
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار ویدیو"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!published ? "انتشار" : "عدم انتشار"}
            />
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات پایه"}/>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان"}
                            setValue={setTitle}
                            value={title}
                        />
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"توضیحات کوتاه"}
                            setValue={setShortDescription}
                            value={shortDescription}
                        />
                        <RaikoCustomAparatInput
                            link={videoLink}
                            changeLink={setVideoLink}
                        />
                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateGlobalInfo}/>
                        </ButtonDivisionSection>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات ساخت"}/>

                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"ساخته شده توسط"}
                                setValue={setCreatedBy}
                                value={createdBy}
                                disabled={true}
                            />
                            <RaikoDateInputOutlined
                                labelText={"تاریخ ساخت"}
                                setValue={setCreatedAt}
                                value={createdAt}
                                disabled={true}
                            />
                        </RaikoGridTwoColumn>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"وضعیت انتشار"}
                            description={[
                                "* با فعالسازی این مورد کاربران قادر به مشاهده ی این ویدیو خواهند بود و در غیر این صورت ویدیو تنها به عنوان پیش نمایش در پنل مدیریت باقی خواهند ماند.",
                            ]}
                        />
                        <div
                            className={css`
                              display: flex;
                              flex-wrap: nowrap;
                              gap: .5rem;
                              width: 100%;
                              flex-grow: 1;

                              > div {
                                width: 100%;
                                flex-grow: 1;
                              }
                            `}>
                            <DatePicker
                                placeholder={"تاریخ انتشار"}
                                inputClass={`custom-input`}
                                className={css`flex-grow: 1;`}
                                mapDays={({date}) => {
                                    let props = {}
                                    let isWeekend = date.weekDay.index === 6

                                    if (isWeekend) props.className = "highlight highlight-red"

                                    return props
                                }}
                                // render={<InputIcon/>}
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={publishedDate}
                                onChange={event => {
                                    setPublishedDate(event.toDate())

                                    /*getDataFromServer(
                                        setTicketFilterReservedDate(new DateObject(event.toDate()).format("YYYY-MM-DD"))
                                    )*/

                                }}
                            />
                            <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdatePublishedDate}/>
                        </div>
                        <RaikoToggleOutlined
                            labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                            setChecked={state => {
                                handleOpenConfirmDialog()
                            }}
                            checked={published}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>

    )
}
export default VideoDetailBasicInformation;